


// Get Infoperson
export const getInfopersonStart =()=>({
    type: "GET_INFOPERSON_START",
});
export const getInfopersonSuccess =(Infoperson)=>({
    type: "GET_INFOPERSON_SUCCESS",
    payload: Infoperson,
});
export const getInfopersonFailure =(error)=>({
    type: "GET_INFOPERSON_FAILURE",
    payload: error,
});

// Update Infoperson
export const updateInfopersonStart =()=>({
    type: "UPDATE_INFOPERSON_START",
});
export const updateInfopersonSuccess =(Infoperson)=>({
    type: "UPDATE_INFOPERSON_SUCCESS",
    payload: Infoperson,
});
export const updateInfopersonFailure =(error)=>({
    type: "UPDATE_INFOPERSON_FAILURE",
    payload: error,
});

// Delete Carte Image
export const CarteImageStart =()=>({
    type: "CARTE_IMAGE_START",
});
export const CarteImageSuccess =(res)=>({
    type: "CARTE_IMAGE_SUCCESS",
    payload: res,
});
export const CarteImageFailure =(error)=>({
    type: "CARTE_IMAGE_FAILURE",
    payload: error,
});